/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import SideNavBar from './Sidebar';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userService } from '../../services/user.services';
import GlobalContext from '../Context/GloablContext';

export default function Layout() {
    const location = useLocation()
    const { setToastmessage, UpdateCall, setUpdateCall, setToastErrorMessage, isSideBar, setToastWarnmessage, restrictKey } = useContext(GlobalContext)
    const navigate = useNavigate()


    return (
        <>
            <div className="flex h-screen overflow-x-hidden">
                <SideNavBar role={'Profile'}  />
                <Outlet />
            </div>
        </>

    )
}
